import { useBrand } from '@bnnvara/brand';
import { GridSpacer } from '@bnnvara/grids';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import useBoundingClientRect from '../../hooks/useBoundingClientRect';
import * as S from './styled';

const BrandTitleBar = ({ showSpacer }) => {
  const brand = useBrand();
  const bar = React.useRef();
  const barLocation = useBoundingClientRect(bar);
  const [barVisible, setBarVisible] = useState(true);
  if (barLocation && barVisible && barLocation.top <= 85) {
    setBarVisible(false);
  }

  // Always render GridSpacer on portal subpages
  if (brand.slug === 'portal') {
    return <GridSpacer />;
  }

  if (barVisible) {
    return (
      <S.BrandTitleContainer ref={bar}>
        <S.BrandTitle>{brand.name}</S.BrandTitle>
      </S.BrandTitleContainer>
    );
  }

  return showSpacer && <GridSpacer />;
};

BrandTitleBar.defaultProps = {
  showSpacer: true,
};

BrandTitleBar.propTypes = {
  showSpacer: PropTypes.bool,
};

export default BrandTitleBar;
